// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lUQ3","select":"styles_select__t0ewN"};